import React from 'react';
import styles from './LoadingCircle.module.scss';

const ConfirmationModal = ({ 
  message, 
  onProceed, 
  onCancel,
  isProceedDisabled = false 
}) => {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <p className={styles.modalMessage}>{message}</p>
        <div className={styles.modalButtons}>
       
          <button
            onClick={onCancel}
            className={`${styles.modalButton} ${styles.cancel}`}
          >
            CANCEL
          </button>
          
        
          <button
            onClick={onProceed}
            className={`${styles.modalButton} ${styles.proceed}`}
            disabled={isProceedDisabled}
          >
            PROCEED
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;